import React from 'react'

const Increase = () => {
    return (
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 256 256" class="me-1 h-4 w-4" height="15" width="15" xmlns="http://www.w3.org/2000/svg"><path d="M208,200H48l80-80Z" opacity="0.2"></path><path d="M133.66,114.34a8,8,0,0,0-11.32,0l-80,80A8,8,0,0,0,48,208H208a8,8,0,0,0,5.66-13.66ZM67.31,192,128,131.31,188.69,192Zm-25-66.34a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,0l80,80a8,8,0,0,1-11.32,11.32L128,51.31,53.66,125.66A8,8,0,0,1,42.34,125.66Z"></path></svg>
    )
}

export default Increase
